import {
  get,
  post
} from './http'

export default {
  //https://www.callmefix.net/api/manager/businessbase/getbusinessinfo?name=zspassenger
  //{"success":true,"totalCount":1,"data":{"ID":3,"CompanyName":"中港客运联营有限公司","ShortName":"zspassenger","LogoUrl":"","Address":"广东省中山市火炬开发区沿江东一路一号","Province":"广东省","City":"中山市","District":"火炬开发区","Longitude":"113.478816","Latitude":"22.569067","BankName":"","BankNO":"","Status":true},"message":"成功返回商户信息"}
  getBusinessInfo(sign) {
    return get('Manager/BusinessBase/getBusinessInfo', {
      name: sign
    });
  },
  //https://www.callmefix.net/api/manager/businessbase/getbusinessaddresslist?name=zspassenger
  //{"success":true,"totalCount":1,"data":[{"ID":1,"BusinessID":3,"MarkName":"中山港","Address":"广东省中山市火炬开发区沿江东一路一号","Province":"广东省","City":"中山市","District":"火炬开发区","Longitude":"113.478816","Latitude":"22.569067","Subsidy":0.00,"Bonus":0.00,"IsDefault":true,"Status":true}],"message":"成功返回商户地址列表"}
  getBusinessAddressList(sign) {
    return get('Manager/BusinessBase/getBusinessAddressList', {
      name: sign
    });
  },
  //获取商户接送价格列表  首个参数为商户标识,第二个参数为商户名 返回结果为
  getBusinessPickupPriceList(sign, MarkName) {
    return get('Manager/BusinessBase/getBusinessPickupPrice', {
      name: sign,
      mark: MarkName
    });
  }
}



// WEBPACK FOOTER //
// ./src/request/businessApi.js